@if (container$ | async; as container) {
	<stages-association-list
		[associationStore]="$any(associationStore)"
		[groups]="groups"
		[messageKeyNone]="messageKeyNone"
		[editable]="editable"
		[showEmptyGroups]="showEmptyGroups"
		[allowCreateElements]="allowCreateElements"
		[targetElementProcessIds]="targetElementProcessIds"
		[class]="classes"
		[container]="container"
		(openBrowse)="openBrowse($event)"
	/>
}
